import React, { forwardRef } from 'react';

import { AGE_OPTIONS } from '@vlabs/api-bindings/src/constants';
import type { Option } from '@vlabs/monokit/shared/ui/options-filter';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { FilterPopover } from '@vlabs/monokit/shared/ui/popovers/filter-popover';
import { Control } from '@vlabs/uikit';
import { isEqual } from 'lodash';
import { useFormContext } from 'react-hook-form';

import st from '../popovers.module.sass';

function AgeFilterPopover(
  {
    name = 'age',
    ...props
  }: FilterPopoverProps<string>,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { watch, setValue } = useFormContext();
  const handleChange = (value: number[]) => {
    setValue(name, value);
  };

  return (
    <FilterPopover
      {...props}
      name={name}
      ref={ref}
    >
      <div className={st.RadioWrapper}>
        {AGE_OPTIONS.raw.map((option: Option<number[]>) => {
          return (
            <Control.Radio
              checked={isEqual(watch(name), option.value)}
              key={option.label}
              label={option.label}
              onChange={() => handleChange(option.value)}
            />
          );
        })}
      </div>
      <div className={st.Divider} />
    </FilterPopover>
  );
}

const AgeFilterPopoverWithRef = forwardRef(AgeFilterPopover);
export { AgeFilterPopoverWithRef as AgeFilterPopover };
